import Carousel from 'react-bootstrap/Carousel';


function ImpactCorousel() {
  return (
    <Carousel>
      <Carousel.Item>
        <img className="d-block w-100" 
                src="https://images.unsplash.com/photo-1548705085-101177834f47?q=80&w=3432&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="First slide" 
                style={{ height: '400px', objectFit: 'cover' }}/>
               
        <h4>Served 2000+ clients across diverse industries.</h4>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Second slide" style={{ height: '400px', objectFit: 'cover' }}/>
   
        <h4>Managing about 150+cr of assets of clients across the country</h4>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2426&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Third slide" style={{ height: '400px', objectFit: 'cover' }}/>
    
        <h4>Expertise in customized portfolio strategies and wealth creation.</h4>
      </Carousel.Item>
    </Carousel>
  );
}

export default ImpactCorousel;